<template>
  <div class="app-container">
    <div class="tb" style="height: 100%">
      <div class="main tb">
        <div class="lr between">
          <div style="display: flex;justify-content: flex-start;">
            <el-date-picker
              v-model="months"
              type="monthrange"
              range-separator="至"
              start-placeholder="开始月份"
              end-placeholder="结束月份"
              value-format="yyyy-MM"
              @change="search(true)">
            </el-date-picker>
          </div>
        </div>
        <div class="main" style="margin-top: 20px;">
          <el-table :data="table.data" height="600px" border
                    :header-cell-style="{background:'#fafafa',color:'#000000'}" v-loading="tableLoading">
            <el-table-column show-overflow-tooltip fixed="left" label="序号" type="index" width="55"
                             align="center"/>
            <el-table-column show-overflow-tooltip label="小区" align="center"
                             prop="communityName"></el-table-column>
            <el-table-column show-overflow-tooltip label="房源" align="center"
                             prop="houseName"></el-table-column>
            <el-table-column show-overflow-tooltip label="房间" align="center"
                             prop="roomName"></el-table-column>
            <el-table-column show-overflow-tooltip label="付款方式" align="center"
                             prop="payType">
              <template slot-scope="scope">
                <span v-if="scope.row.payType == 0">月付</span>
                <span v-if="scope.row.payType == 4">两月付</span>
                <span v-if="scope.row.payType == 1">季付</span>
                <span v-if="scope.row.payType == 2">半年付</span>
                <span v-if="scope.row.payType == 3">年付</span>
              </template>
            </el-table-column>
            <el-table-column show-overflow-tooltip label="状态" align="center"
                             prop="state">
              <template slot-scope="scope">
                <span v-if="scope.row.state == 0">出租中</span>
                <span v-if="scope.row.state == 1">正退</span>
                <span v-if="scope.row.state == 2">违退</span>
              </template>
            </el-table-column>
            <el-table-column show-overflow-tooltip label="押金" align="center"
                             prop="deposit"></el-table-column>
            <el-table-column show-overflow-tooltip label="租金" align="center"
                             prop="rent"></el-table-column>
            <el-table-column show-overflow-tooltip label="开始日期" align="center"
                             prop="startDate"></el-table-column>
            <el-table-column show-overflow-tooltip label="结束日期" align="center"
                             prop="endDate"></el-table-column>
            <el-table-column show-overflow-tooltip label="首次收租日期" align="center"
                             prop="firstRentDate" width="120"></el-table-column>
            <el-table-column show-overflow-tooltip label="备注" align="center"
                             prop="description"></el-table-column>
<!--            <el-table-column show-overflow-tooltip label="操作" width="360" align="center">-->
<!--              <template slot-scope="scope">-->
<!--                <el-button type="text" @click="open(scope.row)">续签</el-button>-->
<!--              </template>-->
<!--            </el-table-column>-->
          </el-table>
        </div>
        <div class="lr end" style="margin-top: 20px;">
          <el-pagination :total="table.total" :page-size="table.query.size" :current-page="table.query.page"
                         layout="total, prev, pager, next" @current-change="currentPageChange"/>
        </div>
      </div>
    </div>
    <el-dialog :visible.sync="rentRecordDialog.visible" :close-on-click-modal="false" width="40%" append-to-body
               title="续签">
      <el-form ref="rentRecordForm" label-position="right" label-width="120px" :model="rentRecordDialog.formData"
               :rules="rules">
        <el-form-item label="管理员：" prop="adminId">
          <el-select filterable  v-model="rentRecordDialog.formData.adminId" placeholder="请选择管理员" clearable style="width: 100%;">
            <el-option v-for="item in admins" :key="item.id" :value="item.id"
                       :label="item.nickname"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="付款方式：" prop="payType">
          <el-select filterable v-model="rentRecordDialog.formData.payType" placeholder="请选择付款方式" clearable
                     style="width: 100%;">
            <el-option v-for="item in payTypes" :key="item.id" :value="item.id"
                       :label="item.name"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="状态：" prop="state">
          <el-select filterable v-model="rentRecordDialog.formData.state" placeholder="请选择状态" clearable
                     style="width: 100%;">
            <el-option v-for="item in states" :key="item.id" :value="item.id"
                       :label="item.name"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="租金：" prop="rent">
          <el-input-number :precision="2" :step="0.1" :min="0" style="width: 100%"
                           v-model="rentRecordDialog.formData.rent"
                           clearable/>
        </el-form-item>
        <el-form-item label="押金：" prop="deposit">
          <el-input-number :precision="2" :step="0.1" :min="0" style="width: 100%"
                           v-model="rentRecordDialog.formData.deposit"
                           clearable/>
        </el-form-item>
        <el-form-item label="中介费：" prop="agencyFee">
          <el-input-number :precision="2" :step="0.1" :min="0" style="width: 100%"
                           v-model="rentRecordDialog.formData.agencyFee"
                           clearable/>
        </el-form-item>
        <el-form-item label="开始日期：" prop="startDate">
          <el-date-picker
            v-model="rentRecordDialog.formData.startDate"
            type="date"
            placeholder="请选择开始日期"
            value-format="yyyy-MM-dd"
            style="width: 100%;">
          </el-date-picker>
        </el-form-item>
        <el-form-item label="结束日期：" prop="endDate">
          <el-date-picker
            v-model="rentRecordDialog.formData.endDate"
            type="date"
            placeholder="请选择结束日期"
            value-format="yyyy-MM-dd"
            style="width: 100%;">
          </el-date-picker>
        </el-form-item>
        <el-form-item label="首次收租日期：" prop="firstRentDate">
          <el-date-picker
            v-model="rentRecordDialog.formData.firstRentDate"
            type="date"
            placeholder="请选择首次收租日期"
            value-format="yyyy-MM-dd"
            style="width: 100%;">
          </el-date-picker>
        </el-form-item>
        <el-form-item label="合同照片：">
          <el-upload
            action="/group1/upload?output=json"
            list-type="picture-card"
            :file-list="fileList"
            :on-success="handleSuccess"
            :on-remove="handleRemove"
            accept="image/gif,image/jpeg,image/png,.gif,.jpeg,.jpg,.png">
            <i class="el-icon-plus"></i>
          </el-upload>
        </el-form-item>
        <el-form-item label="姓名：" prop="name">
          <el-input placeholder="请输入姓名" v-model="rentRecordDialog.formData.name"></el-input>
        </el-form-item>
        <el-form-item label="身份证号：" prop="idCard">
          <el-input placeholder="请输入身份证号" v-model="rentRecordDialog.formData.idCard"></el-input>
        </el-form-item>
        <el-form-item label="手机号：" prop="phone">
          <el-input placeholder="请输入手机号" v-model="rentRecordDialog.formData.phone"></el-input>
        </el-form-item>
        <el-form-item label="工作单位：">
          <el-input placeholder="请输入工作单位" v-model="rentRecordDialog.formData.workPlace"></el-input>
        </el-form-item>
        <el-form-item label="人数：">
          <el-input-number v-model="rentRecordDialog.formData.personTotal" style="width: 100%;"></el-input-number>
        </el-form-item>
        <el-form-item label="床：">
          <el-input-number v-model="rentRecordDialog.formData.furniture.bed" style="width: 100%;"></el-input-number>
        </el-form-item>
        <el-form-item label="桌子：">
          <el-input-number v-model="rentRecordDialog.formData.furniture.board" style="width: 100%;"></el-input-number>
        </el-form-item>
        <el-form-item label="椅子：">
          <el-input-number v-model="rentRecordDialog.formData.furniture.chair" style="width: 100%;"></el-input-number>
        </el-form-item>
        <el-form-item label="沙发：">
          <el-input-number v-model="rentRecordDialog.formData.furniture.sofa" style="width: 100%;"></el-input-number>
        </el-form-item>
        <el-form-item label="衣柜：">
          <el-input-number v-model="rentRecordDialog.formData.furniture.wardrobe" style="width: 100%;"></el-input-number>
        </el-form-item>
        <el-form-item label="冰箱：">
          <el-input-number v-model="rentRecordDialog.formData.furniture.refrigerator" style="width: 100%;"></el-input-number>
        </el-form-item>
        <el-form-item label="洗衣机：">
          <el-input-number v-model="rentRecordDialog.formData.furniture.washingMachine" style="width: 100%;"></el-input-number>
        </el-form-item>
        <el-form-item label="油烟机：">
          <el-input-number v-model="rentRecordDialog.formData.furniture.hood" style="width: 100%;"></el-input-number>
        </el-form-item>
        <el-form-item label="电磁炉：">
          <el-input-number v-model="rentRecordDialog.formData.furniture.microwaveOven" style="width: 100%;"></el-input-number>
        </el-form-item>
        <el-form-item label="燃气灶：">
          <el-input-number v-model="rentRecordDialog.formData.furniture.gasCooker" style="width: 100%;"></el-input-number>
        </el-form-item>
        <el-form-item label="热水器：">
          <el-input-number v-model="rentRecordDialog.formData.furniture.heater" style="width: 100%;"></el-input-number>
        </el-form-item>
        <el-form-item label="空调：">
          <el-input-number v-model="rentRecordDialog.formData.furniture.airConditioning" style="width: 100%;"></el-input-number>
        </el-form-item>
        <el-form-item label="钥匙：">
          <el-input-number v-model="rentRecordDialog.formData.furniture.key" style="width: 100%;"></el-input-number>
        </el-form-item>
        <el-form-item label="备注：" prop="description">
          <el-input type="textarea" :rows="3" placeholder="请输入备注"
                    v-model="rentRecordDialog.formData.description"></el-input>
        </el-form-item>
      </el-form>
      <div class="dialog-btn">
        <el-button @click="rentRecordDialog.visible = false">取消</el-button>
        <el-button type="primary" @click="keepSign" :loading="loading">保存</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>

import {getPageList, continueRent} from "@/api/rentRecord";
import {getList as getAdmins} from "@/api/user";

export default {
  data() {
    return {
      table: {
        query: {
          page: 1,
          size: 10,
          keyWord: '',
          contractDate: ''
        },
        total: 0,
        data: []
      },
      tableLoading: false,
      months: [],
      fileList: [],
      loading: false,
      rentRecordDialog: {
        formData: {
          roomId: '',
          roomName: '',
          adminId: '',
          adminName: '',
          title: '',
          payType: 0,
          state: 0,
          deposit: 0,
          rent: 0,
          startDate: '',
          endDate: '',
          firstRentDate: '',
          contractDate: '',
          description: '',
          breakDescription: '',
          breakDate: '',
          agencyFee: 0,
          workPlace: '',
          personTotal: 0,
          furniture: {
            bed: 1,
            board: 1,
            chair: 1,
            sofa: 1,
            teaTable: 1,
            wardrobe: 1,
            television: 1,
            setTopBox: 1,
            tvCabinet: 1,
            refrigerator: 1,
            washingMachine: 1,
            microwaveOven: 1,
            heater: 1,
            gasCooker: 1,
            hood: 1,
            airConditioning: 1,
            electricityMeterReading: 1,
            waterMterReading: 1,
            key: 1
          }
        },
        visible: false
      },
      rules: {
        roomId: [
          {trigger: 'change', required: true, message: '请选择房间'}
        ],
        adminId: [
          {trigger: 'change', required: true, message: '请选择管理员'}
        ],
        title: [
          {trigger: 'change', required: true, message: '请输入主题'}
        ],
        payType: [
          {trigger: 'blur', required: true, message: '请选择付款方式'}
        ],
        state: [
          {trigger: 'blur', required: true, message: '请选择状态'}
        ],
        deposit: [
          {trigger: 'blur', required: true, message: '请输入押金'}
        ],
        rent: [
          {trigger: 'blur', required: true, message: '请输入租金'}
        ],
        agencyFee: [
          {trigger: 'blur', required: true, message: '请输入中介费'}
        ],
        startDate: [
          {trigger: 'blur', required: true, message: '请选择开始日期'}
        ],
        endDate: [
          {trigger: 'blur', required: true, message: '请选择结束日期'}
        ],
        firstRentDate: [
          {trigger: 'blur', required: true, message: '请选择首次收租日期'}
        ],
        contractDate: [
          {trigger: 'blur', required: true, message: '请选择合同日期'}
        ]
      },
      admins: [],
      payTypes: [
        {
          id: 0,
          name: '月付'
        },
        {
          id: 4,
          name: '两月付'
        },
        {
          id: 1,
          name: '季付'
        },
        {
          id: 2,
          name: '半年付'
        },
        {
          id: 3,
          name: '年付'
        }
      ],
      states: [
        {
          id: 0,
          name: '出租中'
        }
      ],
    }
  },
  mounted() {
    this.search(true)
    this.getAdmins()
  },
  methods: {
    getAdmins() {
      const params = {
        roleId: '2,5'
      }
      getAdmins(params).then(response => {
        if (response.code == 200) {
          // 查询成功
          this.admins = response.data
        }
      })
    },
    // 搜索框查询
    search(flag) {
      this.tableLoading = true
      if (flag) {
        this.table.query.page = 1
        this.table.query.keyWord = ''
      }
      const params = {
        current: this.table.query.page,
        size: this.table.query.size,
        keyWord: this.table.query.keyWord,
        signed: false,
        state: 0,
        withOutEnd: true
      }
      if (this.months && this.months.length > 0) {
        params.startMonth = this.months[0]
        params.endMonth = this.months[1]
      } else {
        params.startMonth = ''
        params.endMonth = ''
      }
      getPageList(params).then(response => {
        if (response.code == 200) {
          // 查询成功
          this.table.data = response.data
          this.table.total = response.count
        } else {
          // 查询失败
          this.$message.error('查询失败!')
        }
        this.tableLoading = false
      })
    },
    // 页码变更
    currentPageChange(page) {
      this.table.query.page = page
      this.search(false)
    },
    open(row) {
      this.rentRecordDialog.formData.oldRentRecordId = row.id
      this.rentRecordDialog.formData.roomId = row.roomId
      this.rentRecordDialog.formData.roomName = row.roomName
      this.rentRecordDialog.formData.houseId = row.houseId
      this.rentRecordDialog.formData.houseName = row.houseName
      this.rentRecordDialog.formData.communityId = row.communityId
      this.rentRecordDialog.formData.communityName = row.communityName
      this.rentRecordDialog.visible = true
      this.$nextTick(() => {
        this.$refs.rentRecordForm.clearValidate()
      })
    },
    handleSuccess(response, file) {
      this.fileList.push({
        uid: file.uid,
        url: response.url
      })
      this.rentRecordDialog.formData.imageUrls = this.fileList.map(item => item.url).join(',')
    },
    handleRemove(file) {
      this.fileList = this.fileList.filter(item => item.url != file.url)
      if (this.fileList && this.fileList.length > 0) {
        this.rentRecordDialog.formData.imageUrls = this.fileList.map(item => item.url).join(',')
      } else {
        this.rentRecordDialog.formData.imageUrls = ''
      }
    },
    keepSign() {
      this.$refs['rentRecordForm'].validate(async (valid) => {
        this.$confirm('确认续签, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.rentRecordDialog.formData.adminName = this.admins.filter(item => item.id == this.rentRecordDialog.formData.adminId)[0].nickname
          const furniture = this.rentRecordDialog.formData.furniture
          if (furniture) {
            this.rentRecordDialog.formData.furniture = JSON.stringify(furniture)
          }
          if (this.rentRecordDialog.formData.idCard && this.rentRecordDialog.formData.name && this.rentRecordDialog.formData.phone) {
            this.rentRecordDialog.formData.state = 4
          } else {
            this.rentRecordDialog.formData.state = 0
          }
          continueRent(this.rentRecordDialog.formData).then(response => {
            if (response.code == 200) {
              // 操作成功
              this.$message.success('操作成功!')
              this.search(false)
              this.rentRecordDialog.visible = false
            } else {
              // 操作失败
              this.$message.error(response.data)
            }
          })
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消'
          })
        })
      })
    }
  }
}
</script>

<style scoped lang="scss">
.contract-main {
  margin: 0 auto;
  width: 770px;
  padding: 15px;
  .flex-1 {
    flex: 1;
  }

  &-content {
    text-align: left;
    width: 100%;
    /deep/ .el-input {
      width: 150px;

      input {
        border: none;
        border-bottom: 1px solid #DCDFE6;
        border-radius: 0;
        height: 25px !important;
        line-height: 20px !important;
      }
    }

    .title1 {
      text-align: center;
      font-size: 20px;
      width: 100%;
    }

    .no {
      text-align: right;
      font-size: 18px;
      width: 100%;

      .noTxt {
        font-weight: bold;
      }

      .noNumber {
        color: red;
      }
    }

    .row {
      width: 100%;
      display: flex;
      align-items: baseline;
      justify-content: flex-start;
      flex-wrap: wrap;
      margin-bottom: 10px;
      line-height: 2;
      font-weight: bold;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/RenewalRentRecord.vue